import Cookies from 'js-cookie';

export function getAuthorizationToken() {
  return Cookies.get('auth');
}

export function IsLoggedIn() {
  return getAuthorizationToken() != null;
}

export function GetSessionId() {
  return Cookies.get('apurataSessionId');
}

export function getAuthorizationheaders() {
  const headers = {};
  const token = getAuthorizationToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
